import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { environment } from '../../../../../../../apps/onmat-zero/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GeogebraService {
  constructor(private http: HttpClient) {}
  getGeogebraId(htmlStatement: string): string {
    const parsedHtml = htmlStatement.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    const regExp = /<geogebra>.*[m]\/(.+)<\/geogebra>/g;
    let geogId;
    const arr = [];
    while ((geogId = regExp.exec(parsedHtml)) !== null) {
      arr.push(geogId[1].trim());
    }
    return this.tekGeogebraReplacer(arr, parsedHtml);
  }

  private tekGeogebraReplacer(geogebraId: string[], htmlStatement: string): string {
    let htmlAux = htmlStatement;
    const geogebraTags = htmlStatement.match(/<geogebra>(.*?)<\/geogebra>/g);
    for (let i = 0; i < geogebraId.length; i++) {
      for (let j = 0; j < geogebraTags.length; j++) {
        if (i === j) {
          htmlAux = htmlAux.replace(geogebraTags[j], () => `<geogebra value="${geogebraId[i]}"></geogebra>`);
        }
      }
    }
    return htmlAux;
  }

  getFilesByFolder(folder: string) {
    return this.http.get<string[]>(`${environment.materials.url}/files?path=/${folder}`);
  }
}
